// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import IPageTitle from "@/models/IPageTitle";

export class State extends CrudState {
  dataList: Array<IPageTitle> = [];
  dataItem: IPageTitle | null = null;
}
